import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Big from 'big.js';
import Order from './Order';
import styles from './styles.module.scss';
import sharedStyles from '../styles.module.scss';

Big.RM = 0;

function Side({ data, maxQty, side, market, onClickOrder }) {
  let node = null;
  const isUp = side === 'buys';

  // This will scroll to bottom whenever the number of sells goes from 0 to n > 0
  // rougly equivalent to 'flex-direction: column-reverse' or 'justify-content: flex-end'
  // overflow scrolling in column-reverse containers is broken in Firefox
  // and overflow scrolling in flex-end containers is broken in Chrome
  // this is a workaround
  useEffect(
    () => {
      if (!isUp) {
        node.scrollTop = node.scrollHeight;
      }
    },
    [data.length] // eslint-disable-line
  );

  return (
    <tbody
      aria-label={`order-book-side-${side}`}
      className={classnames([sharedStyles.tableBody, styles.sideTableBody])}
      ref={el => (node = el)}>
      {/* This spacer forces rows to the bottom of the container equivalent to 'justify-content: flex-end' */}
      {/* overflow scrolling in flex-end containers is broken in Chrome, this is a workaround */}
      {!isUp && <tr className={classnames([sharedStyles.tableRow, styles.spacerRow])} />}
      {data.map(item => (
        <Order
          market={market}
          key={`${item.price}-${item.quantity}`}
          item={item}
          side={side}
          maxQty={maxQty}
          onClick={onClickOrder}
        />
      ))}
    </tbody>
  );
}

Side.propTypes = {
  data: PropTypes.array.isRequired,
  maxQty: PropTypes.string.isRequired,
  side: PropTypes.string.isRequired,
  market: PropTypes.object.isRequired,
  onClickOrder: PropTypes.func.isRequired
};

export default Side;
